










































import Vue from "vue";
import { required, minValue } from "vuelidate/lib/validators";
import dialog from "@/common/mixins/dialog";
import FixOrderInfoCard from "../components/FixOrderInfoCard.vue";
import FixOrderSelectItemCard from "../components/FixOrderSelectItemCard.vue";
import FixOrderRecoverItemCard from "../components/FixOrderRecoverItemCard.vue";
import { FixOrderFindOrderForms } from "../forms/FixOrderFindOrderForms";
import { FixOrderAddItemForm } from "../forms/FixOrderAddItemForm";

import { Order } from "../models/Order";
import { OrderItem } from "../models/OrderItem";
import { Category } from "../models/Category";
import { Item } from "../models/Item";
export default Vue.extend({
  mixins: [dialog],
  components: {
    FixOrderInfoCard,
    FixOrderSelectItemCard,
    FixOrderRecoverItemCard
  },
  validations: {
    fixOrderFindOrderForms: {
      mcNumber: { required }
    },
    fixOrderItemSelectedForm: {
      category: { required },
      item: { required },
      price: { required, minValue: minValue(1) },
      amount: { required, minValue: minValue(1) }
    }
  },
  data() {
    const fixOrderItemSelectedForm: FixOrderAddItemForm = {};
    const recoverItemForm: OrderItem[] = [];
    const fixOrderFindOrderForms: FixOrderFindOrderForms = { mcNumber: "" };
    const orderInfo: Order = {};
    const isLoading = false;
    const categories: Category[] = [];
    const items: Item[] = [];
    return {
      fixOrderFindOrderForms,
      orderInfo,
      isLoading,
      categories,
      items,
      recoverItemForm,
      fixOrderItemSelectedForm
    };
  },
  computed: {
    mcNumberError() {
      return (this as any).$v.fixOrderFindOrderForms.mcNumber.$error
        ? "MC Number is required"
        : "";
    },
    isOrderInfoEmpty() {
      return Object.keys((this as any).orderInfo).length === 0;
    }
  },
  methods: {
    search() {
      this.$v.fixOrderFindOrderForms.$touch();
      if (this.$v.fixOrderFindOrderForms.$invalid) return;
      this.findOrderInfo();
    },
    async findOrderInfo() {
      try {
        this.isLoading = true;
        const { data } = await (this as any).$dep.fixOrderUseCase.getOrderInfo(
          this.fixOrderFindOrderForms
        );
        this.orderInfo = { ...this.orderInfo, ...data };
        this.isLoading = false;
        await this.findCategories();
      } catch (error) {
        this.isLoading = false;
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        }
        this.orderInfo = {};
      }
    },
    async findCategories() {
      try {
        const {
          data
        } = await (this as any).$dep.fixOrderUseCase.getCategoriesByShopId(
          this.orderInfo.shop?.id
        );

        this.categories = data;
      } catch (error) {
        console.log(error);
      }
    },
    async findItemByCategoryId(categoryId: number) {
      try {
        this.fixOrderItemSelectedForm = {
          category: this.fixOrderItemSelectedForm.category
        };
        const {
          data
        } = await (this as any).$dep.fixOrderUseCase.getItemByCategoryId(
          categoryId
        );
        this.items = data;
      } catch (error) {
        console.log(error);
      }
    },
    selectProduct(product: any) {
      this.fixOrderItemSelectedForm = {
        ...this.fixOrderItemSelectedForm,
        amount: product.amount,
        price: product.price
      };
    },
    addItem() {
      this.$v.fixOrderItemSelectedForm.$touch();
      if (this.$v.fixOrderItemSelectedForm.$invalid) return;

      this.recoverItemForm.push({
        item: this.fixOrderItemSelectedForm.item!,
        price: this.fixOrderItemSelectedForm.price!,
        amount: this.fixOrderItemSelectedForm.amount!,
        total:
          this.fixOrderItemSelectedForm.price! *
          this.fixOrderItemSelectedForm.amount!
      });

      this.fixOrderItemSelectedForm = {};
      this.$v.fixOrderItemSelectedForm.$reset();
    },
    async submit() {
      if (this.recoverItemForm.length) {
        try {
          await this.postRecoverOrderItems();
          if (
            await (this as any).alertSuccess(
              "Success",
              "Recover Order Item Success"
            )
          ) {
            this.clear();
          }
        } catch (error) {
          console.log(error.response);
          if (error.response && error.response.status === 400) {
            (this as any).alertError("Error", error.response.data.message);
          } else {
            (this as any).alertError("Error", error);
          }
        }
      } else {
        (this as any).alertError("Error", "No item submit");
      }
    },
    async postRecoverOrderItems() {
      await (this as any).$dep.fixOrderUseCase.postOrderItems(
        this.orderInfo,
        this.recoverItemForm
      );
    },
    deleteProduct(index: number) {
      this.recoverItemForm = this.recoverItemForm.filter((item, _index) => {
        return _index !== index;
      });
    },
    clear() {
      this.$v.$reset();
      this.fixOrderFindOrderForms = { mcNumber: "" };
      this.recoverItemForm = [];
      this.orderInfo = {};
    }
  }
});
